
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.308 7.092c-.169 0-.33.031-.479.089a1.339 1.339 0 00-1.773-.861 1.339 1.339 0 00-1.69-.844V4.062a1.338 1.338 0 00-2.673 0v5.78l-.522-.774-.012-.016a1.57 1.57 0 00-2.093-.328 1.563 1.563 0 00-.68 1.013c-.082.416.004.837.242 1.187l2.326 3.667.01.014c.6.874 1.59 1.395 2.65 1.395h2.61a3.424 3.424 0 003.42-3.42V8.428c0-.737-.6-1.336-1.336-1.336zm.423 5.488a2.51 2.51 0 01-2.507 2.507h-2.61c-.756 0-1.463-.371-1.893-.992l-2.326-3.667-.01-.013a.657.657 0 01-.103-.502.657.657 0 01.286-.426.66.66 0 01.868.125l2.17 3.221V4.062a.424.424 0 01.846 0v4.563h.914V6.744a.424.424 0 01.846 0v1.881h.913V7.562a.424.424 0 01.847 0v1.063h.913v-.197a.424.424 0 01.846 0v4.152zM5.46.411h-.913v1.264h.913V.41zM6.898.95l-.851.934.675.616.851-.934L6.898.95z","fill":"#fff"}}),_c('path',{attrs:{"d":"M8.27 2.932l-1.258.117.084.91 1.258-.118-.084-.91zM3.081.95l-.675.615.851.934.675-.615-.85-.934zM1.71 2.932l-.085.91 1.258.116.085-.91-1.258-.116z","fill":"#fff"}})])
          )
        }
      }
    